var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1a5.28 5.28 0 00-5.273 5.273A5.28 5.28 0 0012 11.547a5.28 5.28 0 005.273-5.274A5.28 5.28 0 0012 1zM18.561 14.992a7.518 7.518 0 00-5.39-2.273h-2.343a7.518 7.518 0 00-5.39 2.273 7.685 7.685 0 00-2.227 5.422c0 .324.262.586.586.586h16.406a.586.586 0 00.586-.586 7.685 7.685 0 00-2.228-5.422z",
    fill: "#52C0A7"
  })));
}

export default SvgAccountIcon;